import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../redux/typings';

export const errorSelector = (state: RootState) => state.error;

export const errorMessageSelector = createSelector(
  errorSelector,
  (error) => error.message,
);
